import React from 'react';
import fr from 'facet-rest';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import FullyRoundedButton from 'Components/ComponentLibrary/Components/Uncategorized/FullyRoundedButton';
import AddIcon from '@material-ui/icons/Add';

const styles = () => ({
  root: {},
});

const AddStrategyButton = ({
  className,
  classes,
  resource,
}) => {
  const { loadModalCollectionByLink } = useModalContext();
  // const { pageContentResource } = usePageContentContext(); //TODO: Should use this rather than passed in resource
  const setupLink = resource?.relationship(fr.relationships.strategySetup.name)?.link('related');

  const handleClick = async () => {
    if (!setupLink) {
      return;
    }
    loadModalCollectionByLink(setupLink.url());
  };

  return (
    <FullyRoundedButton
      className={classNames(classes.root, className)}
      disabled={!setupLink}
      onClick={handleClick}
      test={`facet-plan-add-strategy-button-${resource.id()}`}
    >
      <AddIcon fontSize={'inherit'} />
      {'Manage Strategies'}
    </FullyRoundedButton>
  );
};

AddStrategyButton.defaultProps = {
  className: '',
};

AddStrategyButton.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  resource: PropTypes.object.isRequired,
};

export default withStyles(styles)(AddStrategyButton);
